/* BLMTD scroll engine · pinned frame-sequence hero + garment reveals.
   No dependencies. Driven entirely by data attributes on BLMTD sections. */
(function () {
  if (window.__blmtdScroll) return;
  window.__blmtdScroll = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function seg(p, a, b) { return clamp((p - a) / (b - a), 0, 1); }
  function pad(n) { return ('00' + n).slice(-3); }

  function Feature(root) {
    var track = root.querySelector('.b-feature__track');
    var cv = root.querySelector('canvas');
    var ctx = cv.getContext('2d');
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var useM = mobile && root.dataset.sheetsMobile;
    var pattern = useM ? root.dataset.sheetsMobile : root.dataset.sheetsDesktop;
    var cols = parseInt(useM ? root.dataset.colsMobile : root.dataset.colsDesktop, 10) || 1;
    var rows = parseInt(useM ? root.dataset.rowsMobile : root.dataset.rowsDesktop, 10) || 1;
    var per = cols * rows;
    var N = parseInt(root.dataset.count, 10) || 0;
    var meter = root.querySelector('[data-b-meter]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-b-step]'));
    var garment = root.querySelector('.b-feature__garment');
    var gIn = parseFloat(root.dataset.garmentIn); if (isNaN(gIn)) gIn = 0.72;
    var sheets = [], cur = 0, last = -1, ticking = false;

    if (reduce || !pattern || !N) { root.classList.add('no-motion'); return; }
    var S = Math.ceil(N / per);

    function src(n) { return pattern.replace('{n}', ('0' + (n + 1)).slice(-2)); }
    function load(n) {
      if (sheets[n]) return;
      var im = new Image(); im.decoding = 'async';
      im.onload = function () { if (n === 0) root.classList.add('is-ready'); last = -1; update(); };
      im.src = src(n); sheets[n] = im;
    }
    function ok(n) { var im = sheets[n]; return im && im.complete && im.naturalWidth; }
    function nearest(i) {
      for (var d = 0; d < N; d++) {
        if (i - d >= 0 && ok(Math.floor((i - d) / per))) return i - d;
        if (i + d < N && ok(Math.floor((i + d) / per))) return i + d;
      }
      return -1;
    }
    function paint(i) {
      var f = nearest(i); if (f < 0) return;
      var im = sheets[Math.floor(f / per)], c = f % per;
      var fw = im.naturalWidth / cols, fh = im.naturalHeight / rows;
      var sx = (c % cols) * fw, sy = Math.floor(c / cols) * fh;
      var w = cv.width, h = cv.height, r = Math.max(w / fw, h / fh);
      var dw = fw * r, dh = fh * r;
      ctx.drawImage(im, sx, sy, fw, fh, (w - dw) / 2, (h - dh) / 2, dw, dh);
    }
    function size() {
      var r = cv.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = Math.round(r.width * d); cv.height = Math.round(r.height * d); last = -1; update();
    }
    function progress() {
      var r = track.getBoundingClientRect();
      var stick = root.querySelector('.b-feature__stick').offsetHeight;
      return clamp(-r.top / Math.max(1, r.height - stick), 0, 1);
    }
    function update() {
      ticking = false;
      var p = progress(), f = Math.min(N - 1, Math.floor(p * N)); cur = f;
      steps.forEach(function (el) {
        var a = parseFloat(el.dataset.in || 0), b = parseFloat(el.dataset.out || 2), fade = 0.06;
        el.style.opacity = seg(p, a, a + fade) * (1 - seg(p, b - fade, b));
      });
      if (garment) {
        var g = seg(p, gIn, gIn + 0.1);
        garment.style.opacity = g;
        var gi = garment.firstElementChild;
        if (gi) gi.style.transform = 'translateY(' + ((1 - g) * 48).toFixed(1) + 'px) scale(' + (0.94 + g * 0.06).toFixed(3) + ')';
      }
      if (f !== last) { last = f; paint(f); if (meter) meter.textContent = pad(f + 1) + ' / ' + pad(N); }
    }
    load(0);
    var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 250); };
    idle(function () { for (var n = 1; n < S; n++) load(n); });
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', size);
    size();
  }

  /* 3D turn: plays a pre-rendered frame sheet on a canvas, then hands back to the static image.
     One turn per hover entry or tap; turns cannot be interrupted. */
  function Turn(c, hover) {
    var art = c.querySelector('.b-float__art'), cv = c.querySelector('.b-float__turncv'), tb = c.querySelector('.b-float__turn');
    if (!art || !cv) return;
    var N = parseInt(c.getAttribute('data-turn-n'), 10) || 32, COLS = parseInt(c.getAttribute('data-turn-cols'), 10) || 8;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var D = 1150, sheets = { alt: null, main: null }, busy = false, started = false;
    function load() {
      if (started) return; started = true;
      ['alt', 'main'].forEach(function (k) {
        var im = new Image(); im.decoding = 'async';
        im.onload = function () { (im.decode ? im.decode() : Promise.resolve()).then(function () { sheets[k] = im; }, function () { sheets[k] = im; }); };
        im.src = c.getAttribute('data-turn-' + k);
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { load(); io.disconnect(); } }, { rootMargin: '800px 0px' });
      io.observe(c);
    } else load();
    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function go() {
      if (busy) return;
      var toAlt = !c.classList.contains('is-flipped'), sh = sheets[toAlt ? 'alt' : 'main'];
      if (reduce || !sh) { c.classList.toggle('is-flipped'); return; }
      busy = true;
      var r = art.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
      var px = Math.round(Math.max(r.width, r.height) * dpr);
      if (cv.width !== px) { cv.width = px; cv.height = px; }
      var ctx = cv.getContext('2d'), fw = sh.naturalWidth / COLS, fh = fw, t0 = 0, last = -1;
      function draw(f) {
        if (f === last) return; last = f;
        ctx.clearRect(0, 0, px, px);
        ctx.drawImage(sh, (f % COLS) * fw, Math.floor(f / COLS) * fh, fw, fh, 0, 0, px, px);
      }
      draw(0); c.classList.add('is-turning');
      function step(now) {
        if (!t0) t0 = now;
        var p = Math.min(1, (now - t0) / D);
        draw(Math.min(N - 1, Math.round(ease(p) * (N - 1))));
        if (p < 1) { requestAnimationFrame(step); return; }
        c.classList.toggle('is-flipped');
        requestAnimationFrame(function () { c.classList.remove('is-turning'); busy = false; });
      }
      requestAnimationFrame(step);
    }
    if (hover) c.addEventListener('mouseenter', go);
    if (tb) tb.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(); });
    if (!hover) art.addEventListener('click', function (e) { e.preventDefault(); go(); });
  }

  function Pieces(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.b-piece'));
    var hover = window.matchMedia('(hover: hover)').matches;
    cards.forEach(function (c) {
      if (!c.querySelector('.is-alt')) return;
      var btn = c.querySelector('.b-piece__flip');
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); c.classList.toggle('is-flipped'); });
      if (hover) {
        c.addEventListener('mouseenter', function () { c.classList.toggle('is-flipped'); });
        c.addEventListener('mouseleave', function () { c.classList.toggle('is-flipped'); });
      }
    });
    if (reduce || !('IntersectionObserver' in window)) return;
    cards.forEach(function (c) { if (c.getBoundingClientRect().top > window.innerHeight) c.classList.add('is-pre'); });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('is-pre'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    cards.forEach(function (c) { io.observe(c); });
  }


  /* ---------- Page reveal: the page's sections slide up as they enter (Designjoy-style) ----------
     Runs on any page that has a BLMTD hero. Headings, carousels, product grids and buttons rise
     56px and fade in, staggered. Styles are removed after the move so theme widgets keep working. */
  function Reveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('b-reveal-on');
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section')).filter(function (s) {
      return /template--/.test(s.id) && !s.querySelector('[data-b-feature],[data-b-pieces],[data-b-floor],[data-b-chapter]') && s.offsetHeight > 0;
    });
    var items = [];
    sections.forEach(function (sec) {
      var group = [];
      sec.querySelectorAll('h1,h2,h3,.section-header,.section__title').forEach(function (h) { group.push(h); });
      var car = sec.querySelector('.flickity-enabled');
      if (car) {
        group.push(car);
      } else {
        var grid = null, best = 1;
        sec.querySelectorAll('*').forEach(function (el) {
          var kids = el.children;
          if (kids.length <= best || el.closest('nav,select,.disclosure')) return;
          var cls = kids[0].className, tag = kids[0].tagName;
          var same = Array.prototype.every.call(kids, function (k) { return k.className === cls && k.tagName === tag; });
          if (same && kids[0].querySelector('img,a')) { grid = el; best = kids.length; }
        });
        if (grid) Array.prototype.forEach.call(grid.children, function (k) { if (group.indexOf(k) < 0) group.push(k); });
      }
      sec.querySelectorAll('a[class*="btn"],a[class*="button"],button[class*="btn"]').forEach(function (b) {
        if (!group.some(function (g) { return g.contains(b); })) group.push(b);
      });
      group = group.filter(function (el, i) {
        return !group.some(function (o, j) { return j !== i && o !== el && o.contains(el); });
      });
      if (!group.length && sec.firstElementChild) group.push(sec.firstElementChild);
      group.sort(function (a, b) {
        var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
        return (ra.top - rb.top) || (ra.left - rb.left);
      });
      group.forEach(function (el, i) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
        el.classList.add('b-rise');
        el.style.transitionDelay = Math.min(i, 6) * 150 + 'ms';
        items.push(el);
      });
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('is-in');
        io.unobserve(el);
        setTimeout(function () { el.classList.remove('b-rise', 'is-in'); el.style.transitionDelay = ''; }, 2800);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }


  /* ---------- Floor: words behind, garments floating in front ----------
     Words slide left with the scroll (or drift up). Garments are always there, hovering. */
  function Floor(root) {
    var track = root.querySelector('.b-floor__track');
    var stage = root.querySelector('.b-floor__stage');
    var words = root.querySelector('[data-b-words]');
    var lines = Array.prototype.slice.call(root.querySelectorAll('.b-floor__line'));
    var pieces = Array.prototype.slice.call(root.querySelectorAll('[data-b-float]'));
    var slide = root.classList.contains('b-floor--slide');
    var hover = window.matchMedia('(hover: hover)').matches;
    var mq = window.matchMedia('(max-width: 749px)');
    var widths = [], ticking = false;

    pieces.forEach(function (c) {
      if (c.hasAttribute('data-turn-alt')) { Turn(c, hover); return; }
      if (hover && c.querySelector('.is-alt')) {
        c.addEventListener('mouseenter', function () { c.classList.add('is-flipped'); });
        c.addEventListener('mouseleave', function () { c.classList.remove('is-flipped'); });
      } else if (c.querySelector('.is-alt')) {
        var flip = function (e) { e.preventDefault(); e.stopPropagation(); c.classList.toggle('is-flipped'); };
        var art = c.querySelector('.b-float__art'), tb = c.querySelector('.b-float__turn');
        if (art) art.addEventListener('click', flip);
        if (tb) tb.addEventListener('click', flip);
      }
    });

    function fit() {
      if (!words || !lines.length) return;
      var W = stage.clientWidth, H = stage.clientHeight, m = mq.matches;
      words.style.setProperty('--fs', '100px');
      var widest = 1;
      lines.forEach(function (l) { widest = Math.max(widest, l.scrollWidth); });
      var byH = (H * (m ? 0.6 : 0.74)) / (lines.length * 0.84), fs;
      if (slide && !reduce) fs = Math.min(byH, m ? W * 0.34 : 280);
      else fs = Math.min(100 * (W * (m ? 0.92 : 0.9)) / widest, byH, 260);
      fs = Math.max(32, fs);
      words.style.setProperty('--fs', fs.toFixed(1) + 'px');
      widths = lines.map(function (l) { return l.scrollWidth; });
    }

    if (reduce) { root.classList.add('no-motion'); fit(); window.addEventListener('resize', fit); return; }

    function progress() {
      var r = track.getBoundingClientRect();
      return clamp(-r.top / Math.max(1, r.height - stage.offsetHeight), 0, 1);
    }
    function update() {
      ticking = false;
      var p = progress(), W = stage.clientWidth, vh = stage.clientHeight / 100, k = pieces.length;
      if (slide) {
        lines.forEach(function (l, i) {
          var travel = Math.max((widths[i] || W) - W * 0.35, W * 0.3) * (1 + i * 0.12);
          l.style.transform = 'translate3d(' + ((0.5 - p) * travel).toFixed(1) + 'px,0,0)';
        });
      } else if (words) {
        words.style.transform = 'translate3d(0,' + ((0.5 - p) * 14 * vh).toFixed(1) + 'px,0)';
      }
      pieces.forEach(function (c, i) {
        if (mq.matches && k > 1) {
          var at = clamp((p - 0.12) / 0.7, 0, 1) * (k - 1);
          c.style.transform = 'translate3d(' + ((i - at) * W).toFixed(1) + 'px,0,0)';
        } else {
          c.style.transform = '';
        }
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    function onResize() { fit(); update(); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(onResize);
    onResize();
  }

  /* ---------- Chapter: film loop + one line sliding left ---------- */
  function Chapter(root) {
    var track = root.querySelector('.b-chapter__track');
    var stage = root.querySelector('.b-chapter__stage');
    var word = root.querySelector('[data-b-slide]');
    var v = root.querySelector('.b-chapter__video');
    var mq = window.matchMedia('(max-width: 749px)');
    var ticking = false, cur = '';

    function pick() {
      if (!v) return;
      var m = mq.matches, s = m ? v.dataset.srcM : v.dataset.srcD, po = m ? v.dataset.posterM : v.dataset.posterD;
      if (po) v.poster = po;
      if (!s || s === cur) return;
      cur = s; v.src = s;
      if (!reduce && seen) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    }
    var seen = false;
    if (v && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          seen = e.isIntersecting;
          if (seen) { if (!cur) pick(); if (!reduce) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } }
          else v.pause();
        });
      }, { rootMargin: '200px 0px' }).observe(stage);
    } else pick();

    if (reduce) { root.classList.add('no-motion'); return; }

    function progress() {
      var r = track.getBoundingClientRect();
      return clamp(-r.top / Math.max(1, r.height - stage.offsetHeight), 0, 1);
    }
    function update() {
      ticking = false;
      if (!word) return;
      var p = progress(), W = stage.clientWidth, w = word.scrollWidth;
      var x = W * 0.55 - p * (w + W * 0.1);
      word.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', function () { pick(); update(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    update();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-b-feature]:not([data-b-on])').forEach(function (el) { el.setAttribute('data-b-on', ''); Feature(el); });
    (scope || document).querySelectorAll('[data-b-floor]:not([data-b-on])').forEach(function (el) { el.setAttribute('data-b-on', ''); Floor(el); });
    (scope || document).querySelectorAll('[data-b-chapter]:not([data-b-on])').forEach(function (el) { el.setAttribute('data-b-on', ''); Chapter(el); });
    (scope || document).querySelectorAll('[data-b-pieces]:not([data-b-on])').forEach(function (el) { el.setAttribute('data-b-on', ''); Pieces(el); });
  }
  function boot() {
    init();
    if (document.querySelector('[data-b-feature],[data-b-floor],[data-b-chapter]') && !(window.Shopify && window.Shopify.designMode)) Reveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();